import React from 'react';

import { switchHorizontal } from '@/assets/icons';
import { PublicCopilotLayout } from '@/components/PublicCopilotLayout';
import { ItemsList } from '@/components/shared/ItemsList';
import { privacyPolicyLink, termsOfServiceLink } from '@/config/constants';
import { SvgIcon } from '@material-ui/core';

import styles from '../CopilotPage.module.scss';

const RenderCopilotIntro: React.FC = () => {
	return (
		<PublicCopilotLayout.SplitScreen
			top={
				<div className={styles['flex-to-bottom']}>
					<div className={styles['icons']}>
						<img src="/assets/asaph-1024-no-padding.svg" />
						<SvgIcon component={switchHorizontal} />
						<img src="/assets/pco-copilot-logo.svg" />
					</div>
					<h1>Connect Asaph to Planning Center Services</h1>
					<div className={styles['blurb']}>
						Asaph for Planning Center assists you in choosing the
						best songs for your services.
					</div>
				</div>
			}
			bottom={
				<div className={styles['flex-between']}>
					<div className={styles['content']}>
						<h2>Asaph would like to</h2>
						<ItemsList
							items={[
								{
									label: 'Import songs from Services',
								},
								{
									label: 'Analyze and tag new songs to Asaph',
								},
								{
									label: 'Access services and plans',
								},
							]}
						/>
					</div>
					<div className={styles['footer']}>
						By allowing access you agree to our
						<br />
						<a
							className={styles['link']}
							href={termsOfServiceLink}
							target="_blank"
							rel="noreferrer"
						>
							Terms of Service
						</a>
						{' and '}
						<a
							className={styles['link']}
							href={privacyPolicyLink}
							target="_blank"
							rel="noreferrer"
						>
							Privacy Policy
						</a>
					</div>
				</div>
			}
		/>
	);
};

export default RenderCopilotIntro;
